// handlers
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return IRModel;
    }
});
const _MARKERS = /*#__PURE__*/ _interop_require_wildcard(require("../lib/ImageInfo/MARKERS.js"));
const _index = /*#__PURE__*/ _interop_require_default(require("../lib/ImageInfo/index.js"));
const _modifyImageInfo = require("../lib/utils/modifyImageInfo.js");
const _ANNOTATIONS = /*#__PURE__*/ _interop_require_default(require("../lib/ImageInfo/IRVIEWER/ANNOTATIONS.js"));
const _getImageInfo = /*#__PURE__*/ _interop_require_default(require("../lib/utils/getImageInfo.js"));
const _coordinates = require("../lib/Transforms/coordinates.js");
const _enums = require("../lib/enums");
const _IRRendererAdapter = /*#__PURE__*/ _interop_require_default(require("./IRRendererAdapter.js"));
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interop_require_wildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
        return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
        return {
            default: obj
        };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
        return cache.get(obj);
    }
    var newObj = {
        __proto__: null
    };
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj){
        if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
            var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
            if (desc && (desc.get || desc.set)) {
                Object.defineProperty(newObj, key, desc);
            } else {
                newObj[key] = obj[key];
            }
        }
    }
    newObj.default = obj;
    if (cache) {
        cache.set(obj, newObj);
    }
    return newObj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
class IRModel {
    async loadWASM(path = "") {
        await this.irrenderer.loadWASM(path);
    }
    initialize(...args) {
        this.cleanup();
        this.irrenderer = new _IRRendererAdapter.default(...args);
    }
    cleanup() {
        if (this.irrenderer) {
            this.irrenderer.cleanup();
            this.irrenderer = null;
        }
    }
    async loadPreview(buffer) {
        try {
            if (buffer.byteLength > 0) {
                this.updateImages({
                    preview: buffer
                });
            }
        } catch (error) {
            console.error("Error loading preview:", error);
        }
    }
    updateImages(updatedImages = {}) {
        this.images = _object_spread({}, this.images, updatedImages);
        this.onImages(this.images);
    }
    setImageInfo(newImageInfo = {}) {
        this.imageInfo = newImageInfo;
        this.imageInfoFrame = (0, _getImageInfo.default)(this.imageInfo);
        // callback: imageInfo has updated
        this.onImageInfo(this.getImageInfo());
    }
    setIsReady(nextBool = false) {
        this.isReady = nextBool;
        this.onReady(this.isReady);
    }
    setIsLoading(nextBool = false) {
        this.isLoading = nextBool;
        this.onLoading(this.isLoading);
    }
    setColorbar(nextGradient) {
        this.colorbar = nextGradient;
        this.onColorbar(this.colorbar);
    }
    renderImages(newImageInfo = {}) {
        // typically called once loadImages has been called or once imageInfo has updated
        if (Object.keys(newImageInfo).length > 0) {
            this.setIsLoading(true);
            this.irrenderer.run(newImageInfo);
            const newImageVL = this.irrenderer.getImageVL();
            const newImageIR = this.irrenderer.getImageIR();
            this.updateImages({
                vl: newImageVL,
                ir: newImageIR
            });
            // update marker store
            const imageJSON = this.irrenderer.getJSON() || {};
            if (Object.keys(imageJSON).length > 0) {
                // load local info store
                const { OUTPUT_MARKERS: MARKERS } = imageJSON;
                this.setImageInfo(_object_spread_props(_object_spread({}, newImageInfo), {
                    MARKERS
                }));
                // set the palette gradient
                this.setColorbar(this.irrenderer.getPaletteData());
            }
            this.setIsLoading(false);
        }
    }
    loadImage(data) {
        // typically called whenever a new image-id is loaded
        if (!data) return;
        const { info, preview, visual, irdata } = this.irrenderer.unpack(data);
        try {
            // load renderer
            this.loadPreview(preview);
            this.irrenderer.loadBuffer({
                info,
                visual,
                irdata
            });
            // run renderer
            this.renderImages(info);
        } catch (error) {
            console.error("Error rendering new images:", error);
        }
    }
    // LOCAL STORE UPDATER
    updateImageInfo(newImageInfo = {}, render = true) {
        // update the current image info consumed by irviewer
        if (Object.keys(newImageInfo).length > 0) {
            // update local stores
            this.setImageInfo(newImageInfo);
            // render new images
            render && this.renderImages(newImageInfo);
        }
    }
    updateSettings(settings = {}) {
        let shouldRender = true;
        // gets modified imageInfo then global update to imageInfo
        if (Object.keys(settings).length > 0) {
            const { modifiedImageInfo, changedKeys } = (0, _modifyImageInfo.modifyImageInfo)(settings, this.getImageInfo(), this.CAMERA_FRAME_INDEX);
            // exempt from render
            const exemptFromRender = [
                _enums.ValidSettings.GLOBAL_MARKER_VISIBLE,
                _enums.ValidSettings.TEXTNOTES,
                _enums.ValidSettings.REFERENCE_MARKER_ID,
                _enums.ValidSettings.STATUS,
                _enums.ValidSettings.ASSET_TAG,
                _enums.ValidSettings.OCR_TEXT
            ];
            // do not render if only one change detected and is an exemption
            if (changedKeys.length === 0 || changedKeys.length === 1 && changedKeys.some((item)=>exemptFromRender.includes(item))) {
                shouldRender = false;
            }
            // update imageInfo store
            this.updateImageInfo(modifiedImageInfo, shouldRender);
        }
    }
    updateShapes(shape, action = "update", shapeType = "MARKERS") {
        const handler = shapeType === "MARKERS" ? _MARKERS.default : _ANNOTATIONS.default;
        const keyToUpdate = shapeType === "MARKERS" ? _enums.ImageInfoKeys.MARKERS : _enums.ImageInfoKeys.IRVIEWER;
        let nextPayload;
        let response;
        let { type, id, name, label, points } = shape;
        switch(action){
            case "delete":
                nextPayload = handler.deleteShape(shape, this.getImageInfo());
                break;
            case "update":
            default:
                if (shapeType === "MARKERS") {
                    const marker = this.irrenderer.getMarkerObject({
                        id,
                        type,
                        label,
                        name: name || (0, _MARKERS.getNextMarkerIndex)(type, this.getImageInfo()),
                        points
                    });
                    id = marker.characteristics.uniqueIDString;
                    if (!Object.keys(marker).length) return;
                    nextPayload = handler.modify({
                        id: marker.characteristics.uniqueIDString,
                        type,
                        marker
                    }, this.getImageInfo());
                } else if (shapeType === "ANNOTATIONS") {
                    [id, nextPayload] = handler.update({
                        id,
                        type,
                        label,
                        name,
                        points
                    }, this.getImageInfo());
                }
                break;
        }
        response = id;
        // rebuild a modified image info object
        if (!Object.keys(nextPayload).length) return;
        const nextImageInfo = _index.default.modify(keyToUpdate, nextPayload, this.getImageInfo());
        // do not rerender image on marker updates
        const shouldRender = false;
        this.updateImageInfo(nextImageInfo, shouldRender);
        return response;
    }
    toCanvasCoordinates(point = {}) {
        return (0, _coordinates.getCoordinates)(point, this.irrenderer.scaleOffset, true);
    }
    fromCanvasCoordinates(point = {}) {
        return (0, _coordinates.getCoordinates)(point, this.irrenderer.scaleOffset, false);
    }
    getImageInfo() {
        return _object_spread({}, this.imageInfo || {});
    }
    constructor(props = {}){
        const { legacy = false, path_to_wasm = null, onImageInfo = ()=>{}, onImages = ()=>{}, onReady = ()=>{}, onLoading = ()=>{}, onColorbar = ()=>{} } = props;
        this.legacy = legacy;
        this.onImageInfo = onImageInfo;
        this.onImages = onImages;
        this.onReady = onReady;
        this.onLoading = onLoading;
        this.onColorbar = onColorbar;
        this.CAMERA_FRAME_INDEX = 0;
        this.irrenderer = null;
        this.imageInfo = {};
        this.imageInfoFrame = {};
        this.isLoading = false;
        this.images = {};
        this.colorbar = null;
        this.initialize(path_to_wasm, {
            onReady: this.onReady
        });
    }
}
